<template>
  <div>
    <header-component />
    <div class="px-2 py-2 w-full">
      <div class="flex gap-4">
        <div class="w-1/4">
          <div class="py-2 card">
            <div class="block">
              <div class="flex justify-between border-b">
                <label for="" class="px-2 py-2 font-bold ">Supplier</label>
                <div class="px-2">
                  <base-button
                    size="sm"
                    type="primary"
                    class="export-button"
                    @click="handleAddSupplier()"
                    >Add Supplier</base-button
                  >
                </div>
              </div>
              <div class="px-2">
                <base-input label="Select Supplier" class="mb-0">
                  <el-select v-model="purchase.supplierId" class="w-full">
                    <el-option
                      v-for="(item, index) in supplierList"
                      :key="index"
                      :value="item.supplierId"
                      :label="item.name"
                    />
                  </el-select>
                </base-input>
                <span
                  v-if="formErrors.some(i => i.field === 'supplier')"
                  class="pb-3 text-red"
                >
                  {{ formErrors.find(i => i.field === "supplier").msg }}
                </span>
              </div>
            </div>
            <div class="block px-2 ">
              <base-input
                class="mb-0"
                v-model="purchase.invoiceNumber"
                tabindex="6"
                type="text"
                label="Invoice Number"
              />
              <span
                v-if="formErrors.some(i => i.field === 'invoice')"
                class="pb-3 text-red"
              >
                {{ formErrors.find(i => i.field === "invoice").msg }}
              </span>
            </div>
            <div class="block px-2 ">
              <base-input label="Select Status" class="mb-0">
                <el-select v-model="purchase.status" class="w-full">
                  <el-option
                    v-for="(item, index) in statuses"
                    :key="index"
                    :value="item.value"
                    :label="item.name"
                  />
                </el-select>
              </base-input>
            </div>
          </div>

          <!------------------- Billing Card --------------------------------------------------->
          <div class="card">
            <div class="flex justify-between px-2 py-2 border-b ">
              <label for="" class="font-bold ">Billing</label>
              <div class="flex flex-col">
                <el-date-picker
                  v-model="purchase.date"
                  type="date"
                  value-format="yyyy-MM-dd"
                  class="w-full"
                />
                <span
                  v-if="formErrors.some(i => i.field === 'date')"
                  class="pb-3 text-red"
                >
                  {{ formErrors.find(i => i.field === "date").msg }}
                </span>
              </div>
            </div>
            <div class="flex justify-between px-2 py-2">
              <div class="flex flex-col">
                <h5 class="mb-0 card-title text-uppercase text-muted">
                  Total
                </h5>
                <span class="mb-0 font-weight-bold">
                  {{ total | currency }}
                </span>
              </div>
              <div class="flex flex-col">
                <h5 class="mb-0 card-title text-uppercase text-muted">
                  Rnd. Off
                </h5>
                <span class="mb-0 font-weight-bold">
                  {{ roundOff | currency }}
                </span>
              </div>
              <div class="flex flex-col">
                <h5 class="mb-0 card-title text-uppercase text-muted">
                  Amt. due
                </h5>
                <span class="mb-0 font-weight-bold">
                  {{ amountDue | currency }}
                </span>
              </div>
              <div class="flex flex-col">
                <h5 class="mb-0 card-title text-uppercase text-muted">
                  Pending
                </h5>
                <span class="mb-0 font-weight-bold">
                  {{ amountRemaining | currency }}
                </span>
              </div>
            </div>
            <div class="flex justify-between px-2 py-2">
              <base-input
                ref="discount"
                v-model="purchase.discount"
                :disabled="$route.meta.mode === 'edit' ? true : false"
                tabindex="5"
                label="Discount"
                type="number"
              >
                <base-button
                  v-if="purchase.discountMode === 'percent'"
                  slot="prepend"
                  :disabled="$route.meta.mode === 'edit' ? true : false"
                  type="primary"
                  size="sm"
                  @click="purchase.discountMode = 'amount'"
                >
                  <span class="btn-inner--text" icon="fas fa-percent">
                    <i class="fas fa-percent" />
                  </span>
                </base-button>
                <base-button
                  v-else
                  slot="prepend"
                  :disabled="$route.meta.mode === 'edit' ? true : false"
                  type="primary"
                  size="sm"
                  @click="purchase.discountMode = 'percent'"
                >
                  <span class="btn-inner--text">
                    <i class="fas fa-rupee-sign" />
                  </span>
                </base-button>
              </base-input>
              <div class="col-6">
                <base-input
                  :disabled="$route.meta.mode === 'edit' ? true : false"
                  v-model="purchase.paidAmount"
                  tabindex="6"
                  type="number"
                  :label="
                    $route.meta.mode === 'edit'
                      ? 'Amount Paid'
                      : 'Amount Paying'
                  "
                />
              </div>
            </div>

            <div class="col-12">
              <h5 class="py-2 mb-0 card-title text-uppercase text-muted">
                Payment Mode
              </h5>
              <div>
                <el-radio-group
                  v-model="purchase.paymentModeId"
                  fill="#5e72e4"
                  size="mini"
                >
                  <el-radio-button
                    v-for="(item, index) in paymentModes"
                    :label="item.paymentModeId"
                    :key="index"
                    >{{ item.label }}</el-radio-button
                  >
                </el-radio-group>
              </div>
              <span
                v-if="formErrors.some(i => i.field === 'paymentMode')"
                class="pb-3 text-red"
              >
                {{ formErrors.find(i => i.field === "paymentMode").msg }}
              </span>
            </div>
            <div class="col-12">
              <base-input
                class="mb-0"
                v-model="purchase.paymentNote"
                tabindex="6"
                type="text"
                label="Payment Note"
              />
            </div>
            <div class="px-2 py-2">
              <base-button
                :loading="isLoading"
                style="text-transform: capitalize"
                type="primary"
                @click="handleSubmit()"
                >Submit
              </base-button>
            </div>
          </div>
        </div>
        <div class="w-3/4">
          <!------------------- Purchase items --------------------------------------------------->
          <div class="card">
            <label for="" class="px-2 py-2 font-bold border-b">Items</label>
            <div class="px-2 py-2">
              <div class="flex justify-between">
                <label for="">Advance Search</label>
                <div class="pb-2 pr-2">
                  <base-button
                    size="sm"
                    type="primary"
                    class="export-button"
                    @click="handleAddProduct()"
                    >Add Product</base-button
                  >
                </div>
              </div>
              <base-input class="w-full">
                <el-autocomplete
                  v-uppercase
                  ref="searchProduct"
                  v-model="searchKeyword"
                  :fetch-suggestions="suggestProducts"
                  :trigger-on-focus="false"
                  class="w-full product-search"
                  value-key="name"
                  placeholder="Search Product/Barcode"
                  tabindex="4"
                  @select="handleProductSelect"
                />
              </base-input>

              <div class="overflow-x-auto">
                <table class="min-w-full border border-gray-300">
                  <thead>
                    <tr class="bg-gray-200">
                      <th
                        v-for="header in [
                          'Name',
                          'Price',
                          'Qty.',
                          'D.Type',
                          'Disc',
                          'GST',
                          'Total',
                          ''
                        ]"
                        :key="header"
                        class="px-4 py-2 text-left border"
                      >
                        {{ header }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="" v-if="purchase.items.length === 0">
                      <td colspan="8" class="py-4 text-center text-gray-500">
                        <span class="flex justify-center text-center"
                          >No Items Selected</span
                        >
                        <span
                          v-if="formErrors.some(i => i.field === 'items')"
                          class="pb-3 text-red"
                        >
                          {{ formErrors.find(i => i.field === "items").msg }}
                        </span>
                      </td>
                    </tr>
                    <tr
                      v-else
                      v-for="(item, index) in purchase.items"
                      :key="index"
                      class="border"
                    >
                      <td class="px-2 py-2 text-sm border w-68">
                        {{ item.name }}
                      </td>
                      <td class="w-40 px-2 py-2 border">
                        <input
                          type="number"
                          v-model="item.price"
                          class="w-full px-2 py-1 border"
                          @click="calculateRowTotal"
                        />
                      </td>
                      <td class="w-40 px-2 py-2 border">
                        <input
                          type="number"
                          v-model="item.quantity"
                          class="w-full px-2 py-1 border"
                          @click="calculateRowTotal"
                        />
                      </td>
                      <td
                        class="justify-center w-16 px-2 py-2 text-center border"
                      >
                        <div class="product-discount-type grid-item">
                          <base-button
                            v-if="item.discountMode === 'percent'"
                            slot="prepend"
                            type="primary"
                            size="sm"
                            @click="
                              item.discountMode = 'amount';
                              calculateRowTotal(item);
                            "
                          >
                            <span class="btn-inner--text" icon="fas fa-percent">
                              <i class="fas fa-percent" />
                            </span>
                          </base-button>
                          <base-button
                            v-else
                            slot="prepend"
                            type="primary"
                            size="sm"
                            @click="
                              item.discountMode = 'percent';
                              calculateRowTotal(item);
                            "
                          >
                            <span class="btn-inner--text">
                              <i class="fas fa-rupee-sign" />
                            </span>
                          </base-button>
                        </div>
                      </td>
                      <td class="px-2 py-2 border w-36">
                        <input
                          type="number"
                          v-model="item.discount"
                          class="w-full px-2 py-1 border"
                          @click="calculateRowTotal"
                        />
                      </td>
                      <td
                        class="justify-center w-24 px-2 py-2 text-center border "
                      >
                        <el-select
                          v-model="item.tax"
                          class="w-full"
                          value-key="taxId"
                        >
                          <el-option
                            v-for="(tax, index) in taxes"
                            :key="index"
                            :value="tax"
                            :label="tax.rate + ' ' + '%'"
                          />
                        </el-select>
                      </td>
                      <td class="px-2 py-2 border">
                        <span>
                          <i class="fas fa-rupee-sign" />
                          {{ calculateRowTotal(item) }}
                        </span>
                      </td>
                      <td class="w-10 px-2 py-2 text-center border">
                        <span class="btn-inner--text" @click="removeItem(row)">
                          <i class="el-icon-error" />
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="Add Supplier" :visible.sync="showSupplierModal">
      <add-supplier @close="showSupplierModal = false"></add-supplier>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import headerComponent from "../Components/HeaderComponent";
import createPurchase from "./CreatePurchaseComponent";
import {
  Select,
  Option,
  Autocomplete,
  DatePicker,
  RadioGroup,
  RadioButton,
  Dialog
} from "element-ui";
import Validator from "@/plugins/customValidator";
import AddSupplier from "../../views/Supplier/AddSupplier.vue";

export default {
  directives: {
    uppercase: {
      inserted: function(el, _, vnode) {
        el.addEventListener("input", async function(e) {
          const modified = e.target.value
            .split(" ")
            .map(i => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      }
    }
  },
  components: {
    "header-component": headerComponent,
    "create-purchase": createPurchase,
    "add-supplier": AddSupplier,
    [Select.name]: Select,
    [Option.name]: Option,
    [Autocomplete.name]: Autocomplete,
    [DatePicker.name]: DatePicker,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
    [Dialog.name]: Dialog
  },
  filters: {
    currency(value) {
      const amount = parseFloat(value) || 0;
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR"
      }).format(amount);
    }
  },
  data() {
    return {
      editedPurchase: null,
      searchKeyword: "",
      roundOff: 0,
      isLoading: false,
      formErrors: [],
      showSupplierModal: false,
      purchase: {
        supplierId: "",
        date: new Date().toISOString().split("T")[0], // Default to today
        invoiceNumber: "",
        status: "pending",
        paymentModeId: "",
        paymentNote: "",
        total: 0,
        paidAmount: 0,
        discountMode: "amount",
        discount: 0,
        items: []
      }
    };
  },

  computed: {
    ...mapState("supplier", ["suppliers"]),
    ...mapGetters({
      supplierList: "supplier/getSupplierList",
      paymentModes: "paymentMode/getPaymentModes",
      products: "product/getProducts",
      taxes: "tax/getTaxList",
      statuses: "purchase/getStatuses"
    }),
    total() {
      let total = 0;
      if (this.purchase.items && this.purchase.items.length > 0) {
        total = this.purchase.items.reduce((a, b) => {
          const priceWithoutDiscount = parseFloat(b.price * b.quantity);
          let price = 0;
          let taxAmount = 0;
          let rowTotal = 0;
          if (b.discountMode === "amount") {
            price = priceWithoutDiscount - b.discount;
          } else {
            price =
              priceWithoutDiscount - priceWithoutDiscount * (b.discount / 100);
          }
          taxAmount = parseFloat(price) * parseFloat(b.tax.rate / 100);
          rowTotal = parseFloat(price) + parseFloat(taxAmount);
          return a + rowTotal;
        }, 0);
      }
      const finalTotal = Math.round(total);
      this.roundOff = Math.round((finalTotal - total) * 100) / 100;
      return finalTotal;
    },

    amountDue() {
      let amountDue = this.total;
      if (this.purchase.discountMode === "percent") {
        amountDue = this.total - this.total * (this.purchase.discount / 100);
      } else {
        amountDue = this.total - this.purchase.discount;
      }
      this.purchase.paidAmount = amountDue;

      return amountDue;
    },

    amountRemaining() {
      let amountDue = this.amountDue;
      let remainAmount = this.purchase.paidAmount;
      let amountRemaining = amountDue - remainAmount;
      return amountRemaining;
    }
  },
  mounted() {
    this.getSupplierList();
    this.getPaymentModes();
    this.getTaxes();
    this.getProducts();

    if (this.$route.params.purchaseId) {
      this.fetchPurchase(this.$route.params.purchaseId)
        .then(res => {
          this.purchase = res;
        })
        .catch(error => {
          console.error("Error fetching purchase:", error);
        });
    }
  },

  methods: {
    ...mapActions({
      savePurchase: "purchase/savePurchase",
      updatePurchase: "purchase/updatePurchase",
      getPaymentModes: "paymentMode/getPaymentModes",
      fetchPurchase: "purchase/fetchPurchase",
      getTaxes: "tax/getTaxes",
      getSupplierList: "supplier/getSupplierList",
      getProducts: "product/getProducts",
      getProductData: "product/getProductForPos"
    }),

    ...mapMutations({
      resetSupplier: "supplier/resetSupplier"
    }),

    handleAddProduct() {
      window.open(this.$router.resolve("/products/add").href, "_blank");
    },

    handleAddSupplier() {
      this.resetSupplier();
      this.showSupplierModal = true;
    },

    calculateRowTotal(row) {
      let discountedAmount = 0;
      if (row.discount) {
        if (row.discountMode === "percent") {
          row.isPercentage = true;
          discountedAmount =
            (parseFloat(row.price) *
              parseInt(row.quantity) *
              parseFloat(row.discount)) /
            100;
        } else {
          row.isPercentage = false;
          discountedAmount = parseFloat(row.discount);
        }
      }
      let sum = 0;
      let taxAmount = 0;
      let rowTotal = 0;
      sum = parseFloat(row.price) * parseInt(row.quantity) - discountedAmount;
      taxAmount = sum * (row.tax.rate / 100);
      rowTotal = sum + parseFloat(taxAmount);
      return Math.round(rowTotal * 100) / 100;
    },

    async suggestProducts(query, cb) {
      const result = await this.getProducts({ searchKeyword: query });
      cb(result.rows);
    },

    handleProductSelect(product) {
      if (this.purchase.items.length > 0) {
        const productExist = this.purchase.items.find(i => {
          i.productId === product.productId;
        });
        if (productExist) {
          productExist.quantity = parseInt(productExist.quantity) + 1;
          this.searchKeyword = "";
        } else {
          this.purchase.items.push({
            productId: product.productId,
            name: product.name,
            quantity: 1,
            tax: this.taxes.find(i => i.rate === product.tax.rate),
            price: 0,
            discount: 0,
            discountMode: "amount"
          });
          this.searchKeyword = "";
        }
      } else {
        this.purchase.items.push({
          productId: product.productId,
          name: product.name,
          quantity: 1,
          tax: this.taxes.find(i => i.rate === product.tax.rate),
          price: 0,
          discount: 0,
          discountMode: "amount"
        });
        this.searchKeyword = "";
      }
    },

    validateForm() {
      this.formErrors = Validator.validatePurchaseForm(this.purchase);
      if (this.formErrors.length > 0) {
        this.isLoading = false;
      }
    },

    async handleSubmit() {
      try {
        this.isLoading = true;
        this.validateForm();
        if (this.$route.params.purchaseId) {
          await this.updatePurchase({
            purchaseId: this.$route.params.purchaseId,
            payload: this.purchase
          });
          this.$notify({
            message: "Purchase Updated Successfully!",
            type: "success",
            title: "Success"
          });
          this.isLoading = false;
        } else {
          await this.savePurchase(this.purchase);
          this.$notify({
            message: "Purchase Created Successfully!",
            type: "success",
            title: "Success"
          });
          this.isLoading = false;
        }
        this.$router.push("/purchases/list");
      } catch (error) {
        this.$notify({
          message: "Failed to save purchase. Please try again.",
          type: "error",
          title: "Error"
        });
        this.isLoading = false;
      }
    }
  }
};
</script>

<style>
.is-invalid input {
  border-color: #fb6340;
}
</style>
